"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.burnValidator = void 0;
const ts_types_1 = require("@waves/ts-types");
const validators_1 = require("./validators");
const burnScheme = {
    type: validators_1.isEq(ts_types_1.TRANSACTION_TYPE.BURN),
    senderPublicKey: validators_1.isPublicKey,
    version: validators_1.orEq([undefined, 2, 3]),
    assetId: validators_1.isAssetId,
    amount: validators_1.isNumberLike,
    chainId: validators_1.isNumber,
    fee: validators_1.isNumberLike,
    timestamp: validators_1.isNumber,
    proofs: validators_1.ifElse(validators_1.isArray, validators_1.defaultValue(true), validators_1.orEq([undefined])),
};
exports.burnValidator = validators_1.validateByShema(burnScheme, validators_1.getError);
//# sourceMappingURL=burn.js.map